import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import { GetApiResponse, PaginationType } from '../../types/common'
import { CommonResp, ConfigVendorERCDetailReq, GetDataListResp } from './types'
import { History } from 'history'

export const reset = createStandardAction('admin/settingConfig/RESET_ACTION')<
  void
>()

export const sortingTask = createStandardAction('admin/setting/SORTING')<{
  name: string
  sort?: string
}>()

export const getDataListAction = createAsyncAction(
  'admin/setting-vendor-erc/GET_CONFIG_ERC_LIST_REQUEST',
  'admin/setting-vendor-erc/GET_CONFIG_ERC_LIST_SUCCESS',
  'admin/setting-vendor-erc/GET_CONFIG_ERC_LIST_FAILURE'
)<PaginationType, GetDataListResp, Error>()

export const saveDataAction = createAsyncAction(
  'admin/setting-vendor-erc/UPDATE_CONFIG_DETAIL_REQUEST',
  'admin/setting-vendor-erc/UPDATE_CONFIG_DETAIL_SUCCESS',
  'admin/setting-vendor-erc/UPDATE_CONFIG_DETAIL_FAILURE'
)<ConfigVendorERCDetailReq, CommonResp, any>()

export const resetEvent = createStandardAction(
  'admin/qcType/RESET_EVENT_ACTION'
)<void>()
